import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VeiculoEmSeuNome } from '../../model/veiculo';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-ficha-cadastro-veiculo-proprio-lista',
  templateUrl: './ficha-cadastro-veiculo-proprio-lista.component.html',
  styleUrls: ['./ficha-cadastro-veiculo-proprio-lista.component.scss'],
})
export class FichaCadastroVeiculoProprioListaComponent {
  @Input() veiculos: VeiculoEmSeuNome[];
  @Input() quantidadeCaminhao: number;
  @Output() salvar: EventEmitter<VeiculoEmSeuNome> = new EventEmitter();

  savedVeiculo: VeiculoEmSeuNome;

  constructor() {}

  public addVeiculo(): void {
    this.veiculos.push({});
  }

  public saveVeiculo(veiculo: VeiculoEmSeuNome, index: number): void {
    this.veiculos[index] = {
      ...this.veiculos[index],
      ...veiculo,
      saved: true,
      isEdit: false,
    };
    this.salvar.emit();
  }

  public cancelVeiculo(index: number): void {
    if (this.veiculos[index].isEdit) {
      this.veiculos[index] = { ...this.savedVeiculo, isEdit: false };
      return;
    }
    this.removeVeiculo(index);
  }

  public removeVeiculo(index: number): void {
    this.veiculos.splice(index, 1);
    if (!this.veiculos.length) {
      this.addVeiculo();
    }
    this.salvar.emit();
  }

  public editarVeiculo(index: number): void {
    this.veiculos[index].isEdit = true;
    this.savedVeiculo = cloneDeep(this.veiculos[index]);
  }

  public get showAddVeiculo(): boolean {
    return (
      this.veiculos.length < 3 &&
      this.veiculos.length < this.quantidadeCaminhao &&
      this.veiculos.every((v) => v.saved && !v.isEdit)
    );
  }
}
